import React, { memo, useEffect, useState } from 'react';
import { api, endpoint } from '../../api';
import SplineChart from '../../components/Charts/SplineChart';
import { DatePicker } from 'antd';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';

const { RangePicker } = DatePicker;

const AlarmGraph = memo(({ data, deviceParameters }) => {
    const { site, device, parameter, critical, warning, option = 'min', interval = '1' } = data


    const [parameterName, setParameterName] = useState('')
    const [graphData, setGraphData] = useState([])
    const [from, setFrom] = useState('')
    const [to, setTo] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        console.log({ parameter, deviceParameters })
        if (parameter) {
            const selected = deviceParameters?.find(p => p._id === parameter) //problem with edit alarm
            console.log({ selected })
            setParameterName(selected?.name)
        }
    }, [parameter, device])


    useEffect(() => {
        const body = {
            device,
            interval: interval || 1,
            operator: option || 'min',
            parameters: [parameterName],
            from: from || moment().startOf('day').format('YYYY-MM-DD hh:mm'),
            to: to || moment().endOf('day').format('YYYY-MM-DD hh:mm'),
        }
        if (parameterName) {
            setIsLoading(true)
            api.post(endpoint.parameter_comparison, body, {
                params: { limit: 10, page: 1, type: 'graph' }
            })
                .then(res => {
                    setGraphData(res)
                    setIsLoading(false)
                })
                .catch(err => setIsLoading(false))
        }
    }, [parameterName, option, interval, to, from])

    // if (graphData.length) {
    //     const maximum = Math.max.apply(Math, graphData[0].data.map(d => d.y));
    //     const minimum = Math.min.apply(Math, graphData[0].data.map(d => d.y));
    //     console.log({ maximum, minimum })
    // }

    return (
        <div className='mt-4'>
            <p className="form-label">
                Live preview
                <span className="text-danger" style={{ fontFamily: "monospace", marginLeft: 3 }}>
                    *
                </span>
            </p>
            <Row className='align-items-center'>
                <Col md={6}>
                    <RangePicker
                        presets={{ label: 'date' }}
                        className='w-100'
                        format='YYYY-MM-DD'
                        onChange={(e, dateString) => {
                            setFrom(dateString[0]);
                            setTo(dateString[1]);
                        }}
                    />
                </Col>
                <Col md={6}>
                    <div className="text-danger">
                        Default time range is last 24 hours from current view
                    </div>
                </Col>
            </Row>
            <div className="my-5">
                <SplineChart
                    title=""
                    data={graphData}
                    from={from}
                    to={to}
                    isLoading={isLoading}
                    interval={interval}
                    critical={critical}
                    warning={warning}
                />
            </div>
        </div>
    );
});

export default AlarmGraph;